import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from 'react'
import { useApi } from "../../context/ApiProvider";
import Card from "../Helpers/Card";
import { useParams } from "react-router-dom";
import ActivityIndicator from "../Helpers/ActivityIndicator";
import { Link } from "react-router-dom";

export default function Administrator() {
    const Api = useApi();
    const [administrator, setAdministrator] = useState(false);
    const [updateAdministratorError, setUpdateAdministratorError] = useState(false);
    const [updateAdministratorSuccess, setUpdateAdministratorSuccess] = useState(false);
    const [deleteAdministratorError, setDeleteAdministratorError] = useState(false);
    const [deleteAdministratorSuccess, setDeleteAdministratorSuccess] = useState(false);
    const { administratorId } = useParams();
    const [allClients, setAllClients] = useState(false);
    const [session, setSession] = useState(false);
    const [hasPermission, setHasPermission] = useState(null);
    const [isFetchingAdministrator, setIsFetchingAdministrator] = useState(false);
    const [administratorClients, setAdministratorClients] = useState(false);
    const [isFetchingAdministratorClients, setIsFetchingAdministratorClients] = useState(false);
    const [connectClientSuccess, setConnectClientSuccess] = useState(false);
    const [connectClientError, setConnectClientError] = useState(false);
    const [generatePasswordSuccess, setGeneratePasswordSuccess] = useState(false);
    const [generatePasswordError, setGeneratePasswordError] = useState(false);
    const [welcomeEmailSuccess, setWelcomeEmailSuccess] = useState(false);
    const [welcomeEmailError, setWelcomeEmailError] = useState(false);
    const [partners, setPartners] = useState([]);


    useEffect(() => {
        refresh();

        //Hämta sessionsinformation
        Api.getSession()
            .then((data) => {
                setSession(data || false);
            })
    }, []);

    useEffect(() => {
        if (!administrator || !session?.ID) {
            setHasPermission(null);
            return;
        }

        setHasPermission(administrator.rolf === 0 || session.ID === administrator.creatorId);
    }, [administrator, session]);

    const refresh = () => {
        fetchAdministrator();
        fetchAllClients();
        fetchAdministratorClients();
        fetchPartners();
    }

    const fetchAdministrator = async () => {
        setIsFetchingAdministrator(true);

        Api.get(`/administrators/${administratorId}`)
        .then((data) => { 
            setAdministrator(data);
            //console.log(data);
        })
        .catch(() => {})
        .finally(() => {
            setIsFetchingAdministrator(false);
        })
    }

    const fetchAdministratorClients = async () => {
        setIsFetchingAdministratorClients(true);

        Api.get(`/administrators/${administratorId}/clients`)
            .then((data) => {
                setAdministratorClients(data);
            })
            .catch(() => {})
            .finally(() => {
                setIsFetchingAdministratorClients(false);
            })
    }

    const updateAdministrator = async (values) => {
        return Api.put(`/administrators/${administratorId}`, values)
            .then(() => {
                setUpdateAdministratorSuccess("Administrator updated")
            })
            .catch((e) => {
                setUpdateAdministratorError(`Error: ${e.error}`)
            })
            .finally(() => {
                setTimeout(() => {
                    setUpdateAdministratorSuccess(false);
                    setUpdateAdministratorError(false);
                }, 3000);
            });
    }

    const fetchAllClients = async () => {
        Api.get('/rolf/clients')
        .then((data) => {
          setAllClients(data);
        })
        .catch(() => {});
      }

    const fetchPartners = async () => {
        Api.get('/rolf/partners')
        .then((data) => {
            setPartners(data);
        })
        .catch(() => {})
    }

    const deleteAdministratorFromClient = (clientId, clientName) => {
        if (!window.confirm(`Are you sure you wish to remove this administrator from the client "${clientName}"?`)) { return; }
        Api.delete(`/rolf/clients/${clientId}/administrators/${administratorId}`)
            .then(() => {
                setDeleteAdministratorSuccess("Administrator deleted from client");
                refresh(); //Uppdatera efter borttagning
            })
            .catch(() => {
                setDeleteAdministratorError("An error occured. Try again later.");
            })
            .finally(() => {
                setTimeout(() => {
                    setDeleteAdministratorSuccess(false);
                    setDeleteAdministratorError(false);
                }, 3000);
            });
    }

    const connectToNewClients = async (clientsArr) => {
        return Api.post(`/administrators/${administratorId}/clients`, { clients: [...clientsArr] })
            .then(() => {
                setConnectClientSuccess("Administrator has been connected to the selected client(s).")
            })
            .catch((error) => {
                setConnectClientError("An error occured. Try again later.");
            })
            .finally(() => {
                setTimeout(() => {
                    setConnectClientSuccess(false);
                    setConnectClientError(false);
                }, 3000);
            })
    }

    const generatePassword = async () => {
        setGeneratePasswordError(false);
        setGeneratePasswordSuccess(false);
        if (!window.confirm('Are you sure you wish to reset this administrators password?'))
            return;
        await Api.post(`/rolf/administrators/${administratorId}/generatepassword`).then(data => {
            setGeneratePasswordSuccess('Password generated successfully');
            return true;
        }).catch(e => {
            setGeneratePasswordError(e.error);
            return false;
        }).finally(() => {
            setTimeout(() => {
                setGeneratePasswordSuccess(false);
            }, 3000);
        })
    }

    const sendWelcomeEmail = async (values) => {
        //
        await Api.post(`/rolf/administrators/${administratorId}/sendwelcomeemail`, {
            welcomeEmail: values.welcomeEmail,
            language: values.language
        }).then(data => {
          setWelcomeEmailSuccess('Welcome email sent successfully');
          return true;
        }).catch(() => {
          setWelcomeEmailError("Could not send welcome email");
          return false;
        }).finally(() => {
          setTimeout(() => {
            setWelcomeEmailSuccess(false);
            setWelcomeEmailError(false);
          }, 3000);
        })
      }

    const AdministratorClientRows = () => {
        if (administratorClients) {
            return (
                Array.isArray(administratorClients) && administratorClients.map((client) => {
                    return (<tr key={client.ID}>
                        <td>{client.name}</td>
                        <td><a onClick={() => { deleteAdministratorFromClient(client.ID, client.name); }}>Remove</a></td>
                    </tr>);
                }));
        }
        else {
            return (<tr>
                <td>No clients found...</td>
                <td></td>
            </tr>)
        }
    }

    const SuperAdminField = () => {
        if (session.ID === administratorId) { //Superadmin-fältet visas inte ifall man redigerar sig själv, man kan alltså inte redigera sin egen superadminstatus
            return;
        }
        else {
            return (
                <>
                    <label htmlFor="rolf">Superadmin (has access to all clients)</label>
                    <Field as="select" id="rolf" name="rolf" className="formControl" required>
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                    </Field>
                </>
            );
        }
    }


    if (isFetchingAdministrator || hasPermission === null) {
        return <p>Loading data...</p>
    }

    if (hasPermission === false) {
        return (
            <>
                <p className="formControlError">Unauthorized: A "Superadmin" may only be edited by its creator.</p>
                <Link to="/rolf/administrators">Back to administrators overview</Link>
            </>
        )
    }


    return (
        <div className='grid-container'>
            <section className="grow">
                <h4>Edit administrator</h4>
                <Card>
                    {isFetchingAdministrator ? <p>Loading data...</p> :
                        <>
                            <Formik
                                initialValues={administrator}
                                enableReinitialize={true}
                                onSubmit={(values, { setSubmitting, resetForm }) => {
                                    //Skicka inte med klient-id ifall användaren är superadmin
                                    if (values.rolf === "1") {
                                        values = { ...values, clientId: '', rolf: 1 }
                                    }
                                    else {
                                        values = { ...values, rolf: 0 } //Skicka in integer istället för sträng
                                    }

                                    //När formuläret postas
                                    //console.log("Values: ", values);
                                    updateAdministrator(values)
                                        .then((result) => {
                                            setSubmitting(false);

                                            refresh();
                                            if (result) {
                                                resetForm();
                                            }
                                        })
                                }}>
                                {
                                    ({ isSubmitting, values }) => (
                                        <Form>
                                            {updateAdministratorError ? <div className="formControlError">{updateAdministratorError}</div> : ""}
                                            {updateAdministratorSuccess ? <div className="formControlSuccess">{updateAdministratorSuccess}</div> : ""}

                            <label htmlFor="firstName">First name</label>
                            <Field type="text" id="firstName" name="firstName" className="formControl" required />
                            <label htmlFor="lastName">Last name</label>
                            <Field type="text" id="lastName" name="lastName" className="formControl" required />
                            <label htmlFor="email" >Email</label>
                            <Field type="email" id="email" name="email" className="formControl" required />
                            <label htmlFor="partnerId">Connected to partner</label>
                            <Field as="select" id="partnerId" name="partnerId" className="formControl">
                                <option value={0}>No partner</option>
                                {partners && partners.map((partner) => {
                                    return(<option key={partner.ID} value={Number(partner.ID)}>{partner.name}</option>);
                                }
                                )}
                            </Field>

                                            <SuperAdminField />

                                            <button type="submit" disabled={isSubmitting}>Update administrator {isSubmitting && <ActivityIndicator />}</button>
                                        </Form>
                                    )}
                            </Formik>
                            <span className='meta'>The email address entered here is used to log in to Rolf Administration and is also used for password resets.</span>
                        </>
                    }
                </Card>

                {deleteAdministratorError ? <div className="formControlError">{deleteAdministratorError}</div> : ""}
                {deleteAdministratorSuccess ? <div className="formControlSuccess">{deleteAdministratorSuccess}</div> : ""}

                {isFetchingAdministratorClients ? <p>Loading list of clients of the administrator...</p> :
                    <table>
                        <thead>
                            <tr>
                                <th>This administrator is currently connected to the following clients</th>
                                <th>Remove</th>
                            </tr>
                        </thead>
                        <tbody>

                            <AdministratorClientRows />

                        </tbody>
                    </table>
                }

            </section>
            <section>
                <h4>Connect administrator to clients</h4>
                <Card>

                    {
                        administrator.rolf === 1 ? <p>You cannot connect a "Superadmin" to new clients.</p> :
                            <Formik
                                initialValues={{ clients: [] }}
                                enableReinitialize={true}
                                onSubmit={(values, { setSubmitting, resetForm }) => {
                                    setSubmitting(true);
                                    //Postas

                                    connectToNewClients(values.clients)
                                        .then((result) => {
                                            setSubmitting(false);

                                            refresh();
                                            if (result) { resetForm(); }
                                        })
                                }}
                            >
                                {
                                    ({ isSubmitting, values }) => (
                                        <Form>
                                            {connectClientError ? <div className="formControlError">{connectClientError}</div> : ""}
                                            {connectClientSuccess ? <div className="formControlSuccess">{connectClientSuccess}</div> : ""}
                                            <label htmlFor="clients">Connect to client</label>
                                            <Field as="select" id="clients" name="clients" className="formControl" multiple>
                                                {allClients && allClients.map((c) => {
                                                    return (<option key={c.ID} value={c.ID}>{c.name}</option>);
                                                })}
                                            </Field>
                                            <button type="submit" disabled={isSubmitting}>Connect {isSubmitting && <ActivityIndicator />}</button>
                                        </Form>
                                    )}
                            </Formik>
                    }

                </Card>

                <h4>Reset password</h4>
                <Card>
                    {generatePasswordError ? <div className="formControlError">{generatePasswordError}</div> : ""}
                    {generatePasswordSuccess ? <div className="formControlSuccess">{generatePasswordSuccess}</div> : ""}

                    <Formik
                        initialValues={{ shouldGenereatePassword: false }}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            generatePassword().then(() => {
                                setSubmitting(false);
                                resetForm();
                            });
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <>
                                    <label>
                                        <Field type="checkbox" name="shouldGenereatePassword" required />
                                        Check to generate and send a password to the administrator's email
                                    </label>
                                    <button type="submit" disabled={isSubmitting}>Generate password</button>
                                </>
                            </Form>
                        )}
                    </Formik>
                    <span className='meta'>This will generate a new password and send it to the users email address.</span>
                </Card>

            <h4>Send Welcome email</h4>
            <Card>
            {welcomeEmailSuccess && <div className="formControlSuccess">{welcomeEmailSuccess}</div>}
            {welcomeEmailError && <div className="formControlError">{welcomeEmailError}</div>}

              <Formik
                initialValues={{ welcomeEmail: false, language: 'en' }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  sendWelcomeEmail(values).then(() => {
                    setSubmitting(false)
                    resetForm();
                  })
                }}>
                {({ isSubmitting }) => (
                  <Form>

                    <label>
                      <Field type="checkbox" name="welcomeEmail" required />Check to send a new welcome email to this administrator
                    </label>

                    <label htmlFor="language">Language</label>
                    <Field as="select" name="language" id="language" className="formControl">
                      <option value="en">English</option>
                      <option value="sv">Swedish</option>
                    </Field>

                    <div className="formControl">
                      <button type="submit" disabled={isSubmitting}>Send email</button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>


            </section>
        </div>
    )
}
